import styled, { css } from 'styled-components'
import { generateMedia } from 'styled-media-query'

const media = generateMedia({
  xs: '330px',
  sm: '668px',
  md: '768px',
  lg: '1200px',
})

type progressTypes={
  stage:number
}

export const Wrapper = styled.div`
${css`
  height: 90%;
  width: 80%;
  background: #FFFFFF;
  box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  margin: auto;
${media.lessThan('md')`
height: 100%;

`}
h2{
text-align-last: center;
font-family: 'Comfortaa';
font-style: normal;
font-weight: bold;
color: #000000;
font-size: 23px;
line-height: 33px;
display: grid;
grid-template-columns: 5fr 1fr 5fr;
text-align-last: center;
text-align: -webkit-center;
align-items: center;
margin: 1%;
${media.lessThan('sm')`
display: flex;
flex-direction: column;

`}
${media.lessThan('xs')`
font-size: 16px;
`}
.bodyTitle{
  margin-top: 20%;
}
div{
display: flex;
margin: 2%;
flex-direction: column;
.results{
  font-weight: 200;
}
  }
}
h3{
padding: 5%;
font-family: 'Montserrat';
font-style: normal;
font-weight: 700;
font-size: 24px;
line-height: 29px;
display: flex;
align-items: center;

${media.lessThan('md')`
flex-direction: column;
`}
${media.lessThan('xs')`
font-size: 14px;
`}
  .valor{
    color: #017849;
    font-weight: 800;
  }
}
.input{
  margin: auto;
  width: 80%;
}
.stepButton{
  margin-top: 5%;
  width: 60%;
  margin-left: 20%;
  display: flex;
  gap: 20px;
  justify-content: center;
  box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.2);

}


`
}
`
export const ProgressBar = styled.div`
width: 100%;
height: 2%;
border-radius: 16px;
margin-bottom: 5%;
`
export const Progress = styled.div<progressTypes>`
${({ stage }) => css`
background: linear-gradient(270.04deg, #9FFFC7 0.02%, #017849 97.37%);
width: calc(33.3%*${stage});
height: 100%;
border-radius: 16px;
`
}
`
export const bodyContainer = styled.div`
${css`
width: 100%;
padding-left: 20%;
padding-right: 20%;
span{
  margin-right: 8%;
}
`
}
`
export const ModalInputsContainer = styled.div`

width: 50%;
height: 100%;
display: flex;
flex-direction: column;
padding-bottom: 5%;
${media.lessThan('sm')`
  width:100%;
  `}
label{
  font-family: 'Montserrat';
font-style: normal;
font-weight: 600;
font-size: 14px;
line-height: 17px;
}
margin-top: 5%;
.input{
  margin: 8%;
}
button{
  margin:10% 8% ;
  width: 80%;
}
`
export const ModalImageContainer = styled.div`
padding: 1% 3% 3%;
width: 50%;
height: 100%;
display: flex;
flex-direction: column;
${media.lessThan('sm')`
  width:100%;
  `}
h1{
font-family: 'Comfortaa';
font-style: normal;
font-weight: 400;
font-size: 25px;
line-height: 33px;
color: #000000;
}
h2{
  font-family: 'Comfortaa';
font-style: normal;
font-weight: 400;
font-size: 16px;
line-height: 18px;
color: #828282;
}

img{

max-width: fit-content;
max-height: fit-content;
margin-top: 25%;
}
`
